import { message } from "antd";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { getCategories } from "../../../controller/services/common";
import i18n from "../../../localization/i18n";
import {
  setLoading,
  setMenuTitle,
  setShowMenu,
  setShowSubMenu,
} from "../../../redux/slices/common_slice";
import { convertCurrency, formatNumber } from "../../../utils/helper";
import SourceDetailsCard from "../right-sde-wrapper/SourceDetailsCard";

const ExpensesDetailsCardInner = () => {
  const params = useParams();
  const selectedMonth = useSelector((state) => state.dashboard.selectedMonth);
  const dashboardData = useSelector((state) => state.dashboard.dashboardData);
  const selectedCurrency = useSelector(
    (state) => state.currency.currencySelected
  );
  const exchangeRates = useSelector((state) => state.currency.exchangeRates);
  const { t } = useTranslation();
  const [expenseCategories, setExpenseCategories] = useState([]);
  const [savingCategories, setSavingCategories] = useState([]);
  const dispatch = useDispatch();
  const expenseFields = [
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "FoodCost",
      expenseType: t("dashboard.expenseFields.1.1"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "RentAmount",
      expenseType: t("dashboard.expenseFields.1.2"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      expenseType: t("dashboard.expenseFields.1.3"),
      name: "carInsurance",
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "carMaintenance",
      expenseType: t("dashboard.expenseFields.1.4"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "carPayment",
      expenseType: t("dashboard.expenseFields.1.5"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "clothesCost",
      expenseType: t("dashboard.expenseFields.1.6"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "condoFee",
      expenseType: t("dashboard.expenseFields.1.7"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "footwearCost",
      expenseType: t("dashboard.expenseFields.1.8"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "gasCost",
      expenseType: t("dashboard.expenseFields.1.9"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "giftCost",
      expenseType: t("dashboard.expenseFields.1.10"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "groceriesCost",
      expenseType: t("dashboard.expenseFields.1.11"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "homeMaintenance",
      expenseType: t("dashboard.expenseFields.1.12"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "internetCost",
      expenseType: t("dashboard.expenseFields.1.13"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "mobileBill",
      expenseType: t("dashboard.expenseFields.1.14"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "mortgage",
      expenseType: t("dashboard.expenseFields.1.15"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "propertyTax",
      expenseType: t("dashboard.expenseFields.1.16"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "tenantInsurance",
      expenseType: t("dashboard.expenseFields.1.17"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "sendHomeAmount",
      expenseType: t("dashboard.expenseFields.1.18"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "subscriptionBill",
      expenseType: t("dashboard.expenseFields.1.19"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "transportCost",
      expenseType: t("dashboard.expenseFields.1.20"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "utilitiesAmount",
      expenseType: t("dashboard.expenseFields.1.21"),
    },
    {
      title: t("dashboard.expenseFields.1.title"),
      name: "entertainmentCost",
      expenseType: t("dashboard.expenseFields.1.22"),
    },
  ];
  const fields = [
    {
      title: t("dashboard.expenseFields.2"),
      name: "additionalExpense",
      type: "array",
    },
    {
      title: t("dashboard.expenseFields.3"),
      name: "debtDetails",
      type: "array",
    },
    {
      title: t("dashboard.expenseFields.4"),
      name: "currentSavingUp",
      type: "array",
    },
  ];

  useEffect(() => {
    getCategoriesList("expenses");
    getCategoriesList("savings");
  }, []);

  const getCategoriesList = (type) => {
    dispatch(setLoading(true));
    getCategories(type)
      .then((resp) => {
        if (type === "expenses") {
          const dataArr = resp.data.category
            ?.map((i) => [...i.subTitle])
            .flat(1);
          setExpenseCategories(dataArr);
        } else {
          setSavingCategories(resp.data.category);
        }
      })
      .catch((Err) => {
        message.error(Err.message[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
  const isCurrent = selectedMonth === format(new Date(), "MM-yyyy");
  return (
    <div className="col-12">
      <div className={`row mx-0 all-source-heading theme-change`}>
        <h5 className="mb-0 w-auto">{t("dashboard.expenses")}</h5>
        {!params?.id && isCurrent && (
          <Link
            to={"/settings/edit-form/expenses"}
            onClick={() => {
              dispatch(setShowSubMenu(false));
              dispatch(setShowMenu(false));
              dispatch(setMenuTitle(t("commonStepper.section3")));
            }}
          >
            {t("dashboard.addNewExpense")}
          </Link>
        )}
      </div>
      <div className="row mx-0 source-main-wrapper">
        <div className="col-12">
          {expenseFields.some(
            (item) => dashboardData?.expense?.[item?.name]
          ) && (
            <div className={"row source-details-card expenses-theme"}>
              <div className="col-12">
                <h6 className="mb-0 d-flex align-items-center">
                  {t("dashboard.expenseFields.1.title")}{" "}
                  <span>{t("monthlyTag")}</span>
                </h6>
              </div>
              {expenseFields.map((item) => {
                if (dashboardData?.expense?.[item?.name]) {
                  return (
                    <SourceDetailsCard
                      expensesUIChange={"theme"}
                      amt={dashboardData?.expense?.[item?.name]}
                      title={item?.title}
                      incomeType={item?.expenseType}
                    />
                  );
                }
              })}
            </div>
          )}
          {fields.map((item) => {
            if (
              item.type === "array" &&
              dashboardData?.expense?.[item.name]?.length > 0 &&
              dashboardData?.expense?.[item.name]?.some(
                (i) => i.amount || i?.minPay
              )
            ) {
              return (
                <div className={`row source-details-card expenses-theme`} key={item?.title}>
                  <div className="col-12">
                    <h6 className="mb-0 d-flex align-items-center">
                      {item?.title} <span>{t("monthlyTag")}</span>
                    </h6>
                    {dashboardData?.expense?.[item.name]?.map((innerItem) => {
                      const foundExpenseType = expenseCategories.find(
                        (i) => i.en === innerItem?.type
                      );
                      const foundSavingsType = savingCategories.find(
                        (i) => i.title.en === innerItem?.type
                      );
                      let amt;
                      if (innerItem?.type) {
                        amt = innerItem?.amount;
                      } else if (
                        item?.title === t("dashboard.expenseFields.3")
                      ) {
                        amt = innerItem?.minPay;
                      }

                      if (amt) {
                        return (
                          <div className="sources-name-div">
                            <h5 className="mb-0">
                              {item.name === "additionalExpense"
                                ? foundExpenseType?.[i18n.language] ||
                                  innerItem?.type
                                : item.name === "currentSavingUp"
                                ? foundSavingsType?.title?.[i18n.language] ||
                                  innerItem?.type
                                : innerItem?.title}
                            </h5>
                            <h5 className="mb-0">
                              <small>{selectedCurrency}</small>{" "}
                              {formatNumber(
                                convertCurrency(
                                  amt || 0,
                                  exchangeRates,
                                  selectedCurrency
                                )
                              )}
                            </h5>
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default ExpensesDetailsCardInner;
